import React from 'react'
import { Outlet } from 'react-router-dom'
import Pheader from './Pheader.jsx'
import Psidebar from './Psidebar.jsx'

const ProfileLayout = () => {
  return (
    <div className='flex mt-0 flex-row bg-neutral-100 h-screen w-screen '>
      <Psidebar/>
      <div className="flex-1 h-screen flex flex-col">
       {/* <Pheader/> */}
      <div className='p-6 text-lg leading-8 min-h-0 overflow-auto'>{<Outlet/>}</div>
      </div>

    </div>
  )
}

export default ProfileLayout